import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import DashboardLayout from "./Layout/DashboardLayout";
import AppLayout from "./Layout/AppLayout";
import AddNewRecipe from "./Pages/AddNewRecipe";
import { ProtectedRoute, useAuth } from "./Context/AuthContext"; // Updated import to include useAuth
import RecipesList from "./Pages/RecipesList";
import Profile from "./Pages/Profile.js";
import SettingsPage from "./Pages/SettingsPage";
import MyRecipes from "./Pages/MyRecipesList";
import ActionManager from "./Pages/ActionManager";
import RecipeViewPage from "./Pages/RecipeViewPage";
import EditRecipePage from "./Pages/EditRecipePage";
import LogoutPage from "./Pages/LogoutPage";
import CookRecipe from "./Pages/CookRecipe";
import InventoryPage from "./Pages/InventoryPage";
import CookingHistoryPage from "./Pages/CookingHistoryPage";
import DemoPage from "./Pages/DemoPage";
import CookingProcess from "./Pages/CookingProcess";
import DemoProcess from "./Pages/DemoProcess";
import NotificationPrompt from "./Components/NotificationPrompt.js";
import InventoryBoxes from "./Pages/InventoryBoxes.js";
import DashboardNewPage from "./Pages/DashboardNewPage.jsx";
import CookRecipeNew from "./Pages/CookRecipeNew.jsx";
import PaymentForm from "./Pages/Payment.jsx";
import { GetMeProvider } from "./Context/GetMeContext.js";
import { GetCookLaterRecipeProvider } from "./Context/GetCookLaterRecipeContext.js";
import { KitchenDetailProvider } from "./Context/GetMyKitchenDetailContext.js";
import { MyInventoryProvider } from "./Context/MyInventoryContext.js";

const AppRoutes = () => {
  const { isAuthenticated } = useAuth(); // Get authentication status

  return (
    <Router>
      <NotificationPrompt />
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/" element={<AppLayout />}>
          {!isAuthenticated && <Route path="login" element={<LoginPage />} />}
        </Route>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <GetMeProvider>
                <GetCookLaterRecipeProvider>
                  <KitchenDetailProvider>
                    <MyInventoryProvider>
                      <DashboardLayout />
                    </MyInventoryProvider>
                  </KitchenDetailProvider>
                </GetCookLaterRecipeProvider>
              </GetMeProvider>
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<DashboardNewPage />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="recipes" element={<RecipesList />} />
          <Route path="add-recipe" element={<AddNewRecipe />} />
          <Route path="my-recipes" element={<MyRecipes />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="inventory-box/:boxType" element={<InventoryBoxes />} />
          <Route path="history" element={<CookingHistoryPage />} />
          <Route path="demo" element={<DemoPage />} />
          <Route path="recipe/:recipe_id" element={<RecipeViewPage />} />
          <Route path="action-manager/:recipe_id" element={<ActionManager />} />
          <Route path="edit-recipe/:recipe_id" element={<EditRecipePage />} />
          <Route path="cook-recipe/:recipe_id" element={<CookRecipeNew />} />
          <Route path="cooking-start/:recipe_id" element={<CookingProcess />} />
          <Route path="demo-start" element={<DemoProcess />} />
          <Route path="pay" element={<PaymentForm />} />
          <Route path="logout" element={<LogoutPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
